import { createWebHistory } from "vue-router";
import { createLangRouter } from "vue-lang-router";
import translations from "@/lang/translations";
import localizedURLs from "@/lang/localized-urls";

import HomeView from "@/views/HomeView.vue";
import WelcomeView from "@/views/WelcomeView.vue";

import RocaGroup2021EnResumenView from "@/views/rocagroup/EnResumenView.vue";
import RocaGroup2021PresentacionView from "@/views/rocagroup/PresentacionView.vue";
import RocaGroup2021View from "@/views/rocagroup/RocaGroup2021View.vue";
import RocaGroup2021EnElMundoView from "@/views/rocagroup/EnElMundoView.vue";

import AvanzandoHaciaElFuturoView from "@/views/avanzandohaciaelfuturo/AvanzandoHaciaElFuturoView.vue";
import AvanzandoHaciaElFuturoCrecimientoView from "@/views/avanzandohaciaelfuturo/CrecimientoView.vue";
import AvanzandoHaciaElFuturoExcelenciaOperacionalView from "@/views/avanzandohaciaelfuturo/ExcelenciaOperacionalView.vue";
import AvanzandoHaciaElFuturoInnovacionView from "@/views/avanzandohaciaelfuturo/InnovacionView.vue";
import AvanzandoHaciaElFuturoPersonasView from "@/views/avanzandohaciaelfuturo/PersonasView.vue";
import AvanzandoHaciaElFuturoSostenibilidadView from "@/views/avanzandohaciaelfuturo/SostenibilidadView.vue";
import AvanzandoHaciaElFuturoTransformacionDigitalView from "@/views/avanzandohaciaelfuturo/TransformacionDigitalView.vue";

import InformeFinanceroView from "@/views/informefinancero/InformeFinanceroView.vue";
import MenuMobileView from "@/views/MenuMobileView.vue";
//import InformeFinanceroCuentasView from "@/views/informefinancero/CuentasView.vue";
//import InformeFinanceroDatosMasSignificativosView from "@/views/informefinancero/DatosMasSignificativosView.vue";

import WeAreWaterView from "@/views/wearewater/WeAreWaterView.vue";
import WeAreWaterparticipacionCOP27View from "@/views/wearewater/participacion-COP27View.vue";
import WeAreWaterDiaMundialAguaView from "@/views/wearewater/DiaMundialAguaView.vue";
import WeAreWaterAquanautasView from "@/views/wearewater/AquanautasView.vue";

import PageNotFound from '@/views/PageNotFound.vue';

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView
  },
  {
    path: "/welcome",
    name: "welcome",
    component: WelcomeView
  },
  {
    path: "/menu-mobile",
    name: "menu-mobile",
    component: MenuMobileView
  },
  {
    path: "/roca-group-2022",
    name: "roca_group_2022",
    component: RocaGroup2021View,
    children: [
      {
        path: "presentacion",
        name: "presentacion",
        component: RocaGroup2021PresentacionView
      },
      {
        path: "2022-en-resumen",
        name: "resumen",
        component: RocaGroup2021EnResumenView
      },
      {
        path: "roca-group-en-el-mundo",
        name: "roca-group-en-el-mundo",
        component: RocaGroup2021EnElMundoView
      }
    ]
  },
  {
    path: "/avanzando-hacia-el-futuro",
    name: "avanzando",
    component: AvanzandoHaciaElFuturoView,
    children: [
      {
        path: "crecimiento",
        name: "crecimiento",
        component: AvanzandoHaciaElFuturoCrecimientoView
      },
      {
        path: "excelencia-operacional",
        name: "excelencia-operacional",
        component: AvanzandoHaciaElFuturoExcelenciaOperacionalView
      },
      {
        path: "innovacion",
        name: "innovacion",
        component: AvanzandoHaciaElFuturoInnovacionView
      },
      {
        path: "transformacion-digital",
        name: "transformacion-digital",
        component: AvanzandoHaciaElFuturoTransformacionDigitalView
      },
      {
        path: "sostenibilidad",
        name: "sostenibilidad",
        component: AvanzandoHaciaElFuturoSostenibilidadView
      },
      {
        path: "personas",
        name: "personas",
        component: AvanzandoHaciaElFuturoPersonasView
      }
    ]
  },
  {
    path: "/fundacion-we-are-water",
    name: "fundacion-we-are-water",
    component: WeAreWaterView,
    children: [
      {
        path: "participacion-COP27",
        name: "participacion-COP27",
        component: WeAreWaterparticipacionCOP27View
      },
      {
        path: "dia-mundial-agua",
        name: "dia-mundial-agua",
        component: WeAreWaterDiaMundialAguaView
      },
      {
        path: "aquanautas",
        name: "aquanautas",
        component: WeAreWaterAquanautasView
      }
    ]
  },
  {
    path: "/informe-financiero",
    name: "informe-financero",
    component: InformeFinanceroView,
  },
  {
    path: "/menu-mobile",
    name: "menu-mobile",
    component: MenuMobileView,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: PageNotFound,
  }
];

// Initiate router
const langRouterOptions = {
  defaultLanguage: "es",
  translations,
  localizedURLs
};
const routerOptions = {
  routes,
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'instant',
      }
    }else{
      return {
        left: 0,
        top: 0,
        behavior: 'instant',
      }
    }
  }
};

const router = createLangRouter(langRouterOptions, routerOptions);

export default router;
